import React from "react";
import LegalLayout from "./LegalLayout";

const Privacy = () => (
  <LegalLayout
    title="Privacy Policy"
    updated="June 2026"
    intro={[
      "This Privacy Policy explains how StayFlow (\"StayFlow\", \"we\", \"us\", or \"our\") collects, uses, discloses, and safeguards your information when you use the StayFlow mobile application and the website at www.stayflowapp.in (together, the \"Service\").",
      "StayFlow is an all-in-one hospitality operating system for independent properties and venues such as homestays, hotels, resorts, restaurants, cafes, bars, and lounges. By using the Service, you agree to the collection and use of information in accordance with this Policy.",
    ]}
    sections={[
      {
        heading: "Information We Collect",
        body: [
          "We collect information to provide and improve the Service. The categories of information we may collect include:",
          {
            list: [
              "Account & business information: name, email address, phone number, business/venue name, and registered address.",
              "Operational data you enter: bookings, reservations, room and table availability, orders, menu items, invoices, and financial records.",
              "Guest information you provide: guest names, contact details, and identity proof documents you choose to store for your bookings.",
              "Staff information: staff names, roles, and permission levels you configure.",
              "Content you upload: screenshots or photos of booking messages used by our AI Smart Booking feature to pre-fill forms.",
              "Device & usage data: device type, operating system, app version, log data, and diagnostic information used to keep the Service reliable.",
            ],
          },
        ],
      },
      {
        heading: "How We Use Your Information",
        body: [
          "We use the information we collect to:",
          {
            list: [
              "Provide, operate, maintain, and improve the Service and its features.",
              "Process bookings, orders, invoices, and other operational workflows on your behalf.",
              "Enable AI Smart Booking to read uploaded images and pre-fill booking details.",
              "Sync your data securely across devices, including after periods of offline use.",
              "Communicate with you about updates, security notices, and support requests.",
              "Detect, prevent, and address technical issues, fraud, or misuse.",
            ],
          },
        ],
      },
      {
        heading: "AI Smart Booking & Uploaded Images",
        body: [
          "When you use AI Smart Booking, you may upload a screenshot or photo of a booking message. This content is processed to automatically extract booking details and pre-fill the relevant form.",
          "You are responsible for ensuring you have the right to upload such content and that it does not contain information you are not permitted to share. You may delete uploaded content associated with your account at any time.",
        ],
      },
      {
        heading: "Offline Use & Data Sync",
        body: [
          "StayFlow is designed to work fully offline. When your device is offline, data you create or edit is stored locally on the device. Once a network connection is restored, this data is synchronized to our servers so it is backed up and available across your devices.",
        ],
      },
      {
        heading: "How We Share Information",
        body: [
          "We do not sell your personal information. We may share information only in the following limited circumstances:",
          {
            list: [
              "Service providers: trusted vendors who host our infrastructure, process data, or provide AI processing, bound by confidentiality obligations.",
              "Legal compliance: when required to comply with applicable law, regulation, legal process, or a valid governmental request.",
              "Business transfers: in connection with a merger, acquisition, or sale of assets, subject to this Policy.",
              "With your direction: when you choose to export, share, or transmit data using the Service.",
            ],
          },
        ],
      },
      {
        heading: "Data Retention",
        body: [
          "We retain your information for as long as your account is active or as needed to provide the Service, comply with our legal obligations, resolve disputes, and enforce our agreements. You may request deletion of your data as described below.",
        ],
      },
      {
        heading: "Data Security",
        body: [
          "We implement reasonable administrative, technical, and physical safeguards designed to protect your information. However, no method of transmission or storage is completely secure, and we cannot guarantee absolute security.",
        ],
      },
      {
        heading: "Your Rights & Choices",
        body: [
          "Depending on your location, you may have the right to access, correct, update, or delete your personal information, and to object to or restrict certain processing.",
          "To exercise these rights, or to request deletion of your account and associated data, contact us at stayflow.admin@gmail.com. We will respond within a reasonable timeframe.",
        ],
      },
      {
        heading: "Children's Privacy",
        body: [
          "The Service is intended for businesses and is not directed to individuals under the age of 18. We do not knowingly collect personal information from children.",
        ],
      },
      {
        heading: "Third-Party Platforms",
        body: [
          "The Service may be distributed through platforms such as the Apple App Store and Google Play, and may reference services provided by Meta. Your use of those platforms is also governed by their respective terms and privacy policies.",
        ],
      },
      {
        heading: "Changes to This Policy",
        body: [
          "We may update this Privacy Policy from time to time. We will post the updated version on this page and revise the \"Last updated\" date above. Continued use of the Service after changes constitutes acceptance of the updated Policy.",
        ],
      },
      {
        heading: "Contact Us",
        body: [
          "If you have questions or requests regarding this Privacy Policy, please contact us at stayflow.admin@gmail.com or by post at StayFlow, 163, Jyoti Nagar, Bongaon, Part - 3, Golaghat, Assam - 785621 (India).",
        ],
      },
    ]}
  />
);

export default Privacy;
